import { Switch } from '@mantine/core';
import { Controller, FieldValues, Path, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type ActivePropsType<T extends FieldValues> = {
  fieldName: Path<T>;
};

export const Active = <T extends FieldValues>({
  fieldName,
}: ActivePropsType<T>): React.ReactElement => {
  const { t } = useTranslation();
  const { control } = useFormContext<T>();

  return (
    <Controller
      control={control}
      name={fieldName}
      render={({ field: { value, onChange, onBlur, ref } }) => (
        <Switch
          ref={ref}
          checked={value}
          onChange={(event) => onChange(event.currentTarget.checked)}
          onBlur={onBlur}
          label={t('REPORTS.MAILING_FORM.ACTIVE')}
          color="blue"
        />
      )}
    />
  );
};
